import React from 'react';

import { SRLWrapper } from "simple-react-lightbox";

import MiDataTableUplmPlus2List from './MiDataTableUplmPlus2List';


function UplmPlus2List(props){
    
    const { id, adjuntosExistentes, saveAdjuntosExistentes, readonly, estadoForm, traduction, datatable, optionSelect } = props; 

    const _URL = window.URL || window.webkitURL;

    return(
            <SRLWrapper>
                    {
                        adjuntosExistentes
                        ?
                            <MiDataTableUplmPlus2List
                                id={id}
                                columnas={datatable.columns}
                                adjuntosExistentes={ adjuntosExistentes }
                                saveAdjuntosExistentes={ saveAdjuntosExistentes }
                                readonly={ readonly }
                                optionSelect={optionSelect}
                                estadoForm= { estadoForm }
                                columnactions={datatable.columnactions.title}
                                traduction={traduction}
                                buttons={ datatable.buttons}
                                ordering={ datatable.ordering}
                                order={ datatable.order}
                                searching={ datatable.searching}
                                paging={ datatable.paging}
                                select={ datatable.select}
                                grouping={ datatable.grouping}
                                pagelength={ datatable.pagelength }
                                adjuntosplegados={datatable.adjuntosplegados}
                            />   
                        :
                            null
                    }
            </SRLWrapper>                               
    )
}

export default UplmPlus2List;